<template>
  <slot />
</template>

<script setup lang="ts">
import { provide } from "vue";

import type { OverflowMenu } from "./overflowMenu";
import { SCA_OVERFLOW_MENU } from "./overflowMenu";

const props = defineProps<OverflowMenu>();

provide(SCA_OVERFLOW_MENU, { close: () => props.close() });
</script>
